// action 类型定义
export const OrganizationList_ACTION_TYPE = {
  GET_DATA: 'get_data_orgl', // 获取数据
  SET_DATA: 'set_data_orgl', // 设置数据
}
// 当前状态接口
export interface OrganizationListState {
  OrganizationListData: { title: string; value: string }[]
}
// 默认数据
const defaultState: OrganizationListState = {
  OrganizationListData: [],
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case OrganizationList_ACTION_TYPE.SET_DATA:
      arr.OrganizationListData = action.value
      return arr
    default:
      return state
  }
}
// Action Creators
// 获取数据
export const getOrganizationdataAction = () => ({
  type: OrganizationList_ACTION_TYPE.GET_DATA,
})
// 设置数据
export const setdataAction = (param: any[]) => ({
  type: OrganizationList_ACTION_TYPE.SET_DATA,
  value: param,
})
// action 类型定义
export const OrganizationList_ACTION_TYPE = {
  GET_DATA: 'get_data_orgl', // 获取数据
  SET_DATA: 'set_data_orgl', // 设置数据
}
// 当前状态接口
export interface OrganizationListState {
  OrganizationListData: { title: string; value: string }[]
}
// 默认数据
const defaultState: OrganizationListState = {
  OrganizationListData: [],
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case OrganizationList_ACTION_TYPE.SET_DATA:
      arr.OrganizationListData = action.value
      return arr
    default:
      return state
  }
}
// Action Creators
// 获取数据
export const getOrganizationdataAction = () => ({
  type: OrganizationList_ACTION_TYPE.GET_DATA,
})
// 设置数据
export const setdataAction = (param: any[]) => ({
  type: OrganizationList_ACTION_TYPE.SET_DATA,
  value: param,
})
